/** Einstellungen des eigenen Mandanten -- F5-13, F1-05, F5-10. */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';
import { ApiError } from '../../lib/apiError';

export type TenantSettings = components['schemas']['TenantSettingsRead'];

const tenantSettingsKey = ['tenant-settings'] as const;

export function useTenantSettings() {
  return useQuery({
    queryKey: tenantSettingsKey,
    queryFn: () => request<TenantSettings>('/tenant-settings'),
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.isPermanent) && failureCount < 2,
  });
}

/**
 * Aendert Einstellungen des eigenen Mandanten.
 *
 * Der Rumpf traegt **keine** Mandantenkennung -- welcher Mandant gemeint ist,
 * sagt die Sitzung (unverhandelbare Regel 1 aus CLAUDE.md).
 */
export function useUpdateTenantSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) =>
      request<TenantSettings>('/tenant-settings', { method: 'PATCH', body: payload }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: tenantSettingsKey });
    },
  });
}
